export const TITLE = "No contás con permiso para acceder a esta sección.";
